import { useIntl } from 'react-intl';
import { AnalyticsDataClickArea } from 'src/types/googleAnalyticsEvents';
import { useEventGeneratorClickCta } from 'src/analytics/useEventGeneratorClickCta';
import { useLanguagePairLinks } from 'src/hooks/useLanguagePairLinks';
import { Button } from 'src/components';
import { SocialLink } from './SocialLink';
import { useSocialLinks } from './hooks/useSocialLinks';
import { msgs } from './messages';
import * as S from './styles';

type FooterProps = {
  className?: string;
};

export const Footer = ({ className }: FooterProps) => {
  const intl = useIntl();

  const { coursesLinks, generalLinks, languagesLinks, phrasebookLinks, signUpHref, termsLinks } =
    useLanguagePairLinks();

  const socialLinks = useSocialLinks();

  const eventGeneratorClickCta = useEventGeneratorClickCta({
    clickArea: AnalyticsDataClickArea.footer,
  });

  return (
    <S.Footer className={className} data-testid="footer">
      <S.LogoLink />

      <S.ScenariosLinkButtonContainer>
        <Button
          analyticsEvent={eventGeneratorClickCta}
          buttonSize="large"
          buttonType="primary"
          disableMinWidth
          href={signUpHref}
        >
          {intl.formatMessage(msgs.startLearning)}
        </Button>
      </S.ScenariosLinkButtonContainer>

      <S.SocialLinksList>
        {socialLinks.map(link => (
          <S.LinksListItem key={link.href}>
            <SocialLink link={link} />
          </S.LinksListItem>
        ))}
      </S.SocialLinksList>

      <S.InternalLinksContainer>
        {Object.entries({
          generalLinks,
          languagesLinks,
          coursesLinks,
          phrasebookLinks,
        }).map(([key, links]) => (
          <S.InternalLinksList key={key}>
            {links.map(({ href, text }) => (
              <S.InternalLinksListItem key={href}>
                <S.InternalLink data-testid="internalLink" href={href}>
                  {text}
                </S.InternalLink>
              </S.InternalLinksListItem>
            ))}
          </S.InternalLinksList>
        ))}
      </S.InternalLinksContainer>

      <S.TermsLinksList>
        {termsLinks.map(({ href, text }) => (
          <S.LinksListItem key={href}>
            <S.TermsLink data-testid="termsLink" href={href}>
              {text}
            </S.TermsLink>
          </S.LinksListItem>
        ))}
      </S.TermsLinksList>
    </S.Footer>
  );
};
